import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommentEffects } from '@app/store/effects';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ComplaintFormModule } from '@shared/complaint-form/complaint-form.module';
import { IconComponent } from '@shared/icon/icon.component';
import { DateFnsModule, FormatDistanceToNowStrictPurePipeModule } from 'lingo2-ngx-date-fns';

// модули
import { OnUiCoverModule } from 'onclass-ui';
import { CoreModule } from '../../core.module';
import { PipesModule } from '../../pipes/pipes.module';
import { ModalModule } from '../modal/modal.module';
import { SpinnersModule } from '../spinners/spinners.module';

// компоненты
import { CommentComponent } from './comment/comment.component';
import { CommentFormComponent } from './comment-form/comment-form.component';
import { ContentCommentsComponent } from './content-comments.component';
import { commentFeatureKey, reducer } from '@app/store/reducers/comment.reducer';

@NgModule({
  declarations: [ContentCommentsComponent, CommentComponent, CommentFormComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TranslateModule,
    SpinnersModule,
    DateFnsModule,
    CoreModule,
    ModalModule,
    PipesModule,
    ComplaintFormModule,
    MobileModalModule,
    OnUiCoverModule,
    StoreModule.forFeature(commentFeatureKey, reducer),
    EffectsModule.forFeature([CommentEffects]),
    FormatDistanceToNowStrictPurePipeModule,
    IconComponent,
  ],
  exports: [ContentCommentsComponent, CommentComponent],
})
export class CommentsModule {}
